import Vue from "vue"

export default {
    namespaced: true,
    state: {
        deviations: null,
        loading: false
    },

    getters: {
        deviations: state => state.deviations,
        loading: state => state.loading
    },

    mutations: {
        SET_STAGE: (state, stage) => {
            state.stage = stage
        },
        SET_DEVIATION: (state, data) => {
            state.deviations = data
        },
        SET_LOADING: (state, data) => {
            state.loading = data
        },
    },

    actions: {
        SET_STAGE: function ({commit}, data) {
            commit('SET_STAGE', data);
        },
        LOAD_DEVIATION: async function ({commit}) {
            commit('SET_LOADING', true)

            await this.$api.deviation.getList()
                .then((response) => {
                    commit('SET_DEVIATION', response.data);
                })
                .catch((response) => {
                    Vue.prototype.$notify.error({
                        title: "Ошибка загрузки списка 😕",
                        message: response.response.data.message,
                    });
                }).finally(() => {
                    commit('SET_LOADING', false)
                });
        },
        SAVE_ZONE: async function ({commit}, payload) {
            commit('SET_LOADING', true)

            let method = (!payload.pointId) ? 'saveZone' : 'updateZone'

            return new Promise((resolve, reject) => {

                this.$api.deviation[method](payload)
                    .then(response => {
                        commit('SET_LOADING', false)
                        resolve(response.data)
                    }, error => {
                        commit('SET_LOADING', false)
                        reject(error)
                    })
            })

        }

    },
};
